import { USER_LOGIN_SUCCESS } from '../constants/auth';

export const loginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return { userInfo: action.payload };

    default:
      return state;
  }
};
